export const claimGroupMenuItemsCreator = () => {
  return [];
};